import React from "react";
import StateContainer from "./state-container";

const DataContainer = (props) => {
    return (
        <StateContainer {...props}/>
    )
}

export default DataContainer;